export const APP_NAME = "Giulia for models"
